export default {
  feed: [],
  categories: [],
  courses: [],
  featured: [],
  archives: [],
  course: {},
  lessons: [],
  categoryLessons: {},
  freebies: [],
  lesson: {},
  live: {},
  count: 0,
  product: {},
  trails: [],
  trail: {},
  resource: {},
  microlearning: {},
  microlearnings: [],
  homeCategories: []
};
